/*
 * Home estilo Timex (secciones rgt-home-*), 26-sep-2026.
 * Tres elementos: el hero rotativo, los videos y las flechas de los carriles.
 * Cada sección carga este archivo; el guard de customElements evita
 * definirlos dos veces.
 */
(function () {
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var ICONO_PAUSA = '<svg viewBox="0 0 16 16" aria-hidden="true"><rect x="3" y="2" width="3.4" height="12"/><rect x="9.6" y="2" width="3.4" height="12"/></svg>';
  var ICONO_PLAY = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2l10 6-10 6z"/></svg>';

  /* ── Video: se reproduce solo cuando se ve y nadie lo pausó ── */
  if (!customElements.get('rgt-home-video')) {
    customElements.define('rgt-home-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.video.muted = true;
        this.video.playsInline = true;
        if (this.video.dataset.posterMovil && window.matchMedia('(max-width: 749px)').matches) {
          this.video.poster = this.video.dataset.posterMovil;
        }
        this.pausadoPorUsuario = quieto;
        if (quieto) {
          this.video.removeAttribute('autoplay');
          this.video.pause();
        }
        this.boton = this.querySelector('.rgt-home-video__pausa');
        if (this.boton) this.boton.addEventListener('click', () => this.alternar());
        this.pintar();

        this.visible = false;
        this.observador = new IntersectionObserver((entradas) => {
          this.visible = entradas[0].isIntersecting;
          this.sincronizar();
        }, { threshold: 0.2 });
        this.observador.observe(this);
      }

      disconnectedCallback() {
        if (this.observador) this.observador.disconnect();
      }

      // El hero puede frenar todo con su propio botón.
      detenidoPorHero() {
        var hero = this.closest('rgt-home-hero');
        return hero ? hero.corriendo === false : false;
      }

      sincronizar() {
        if (!this.video) return;
        var debe = this.visible && !this.pausadoPorUsuario && !this.detenidoPorHero();
        if (debe && this.video.paused) {
          var p = this.video.play();
          if (p && p.catch) p.catch(function () {}); // modo ahorro de iPhone: queda la portada
        } else if (!debe && !this.video.paused) {
          this.video.pause();
        }
      }

      alternar() {
        this.pausadoPorUsuario = !this.pausadoPorUsuario;
        this.sincronizar();
        this.pintar();
      }

      pintar() {
        if (!this.boton) return;
        this.boton.setAttribute('aria-label', this.pausadoPorUsuario ? 'Reproducir el video' : 'Pausar el video');
        this.boton.innerHTML = this.pausadoPorUsuario ? ICONO_PLAY : ICONO_PAUSA;
      }
    });
  }


  /* ── Video de YouTube de fondo (videos oficiales de las marcas) ──
     El iframe se crea tarde (después de load) y solo si se ve. Se controla
     con la API de postMessage de YouTube: playVideo / pauseVideo. */
  var paginaCargada = document.readyState === 'complete';
  if (!paginaCargada) window.addEventListener('load', function () { paginaCargada = true; document.querySelectorAll('rgt-home-yt').forEach(function (y) { y.sincronizar(); }); }, { once: true });

  if (!customElements.get('rgt-home-yt')) {
    customElements.define('rgt-home-yt', class extends HTMLElement {
      connectedCallback() {
        this.visible = false;
        this.observador = new IntersectionObserver((e) => { this.visible = e[0].isIntersecting; this.sincronizar(); }, { threshold: 0.2 });
        this.observador.observe(this);
      }

      disconnectedCallback() {
        if (this.observador) this.observador.disconnect();
      }

      detenidoPorHero() {
        var hero = this.closest('rgt-home-hero');
        return hero ? hero.corriendo === false : false;
      }

      crear() {
        var id = this.dataset.id;
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&mute=1&loop=1&playlist=' + id +
          '&controls=0&playsinline=1&rel=0&modestbranding=1&iv_load_policy=3&disablekb=1&enablejsapi=1';
        f.title = 'Video';
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        f.setAttribute('tabindex', '-1');
        f.setAttribute('aria-hidden', 'true');
        f.addEventListener('load', () => {
          // La portada se va cuando el video ya arrancó, sin parpadeo del título de YouTube.
          setTimeout(() => this.classList.add('is-listo'), 1400);
        });
        this.appendChild(f);
        this.iframe = f;
      }

      mandar(func) {
        if (this.iframe && this.iframe.contentWindow) {
          this.iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [] }), '*');
        }
      }

      sincronizar() {
        var debe = this.visible && !quieto && !this.detenidoPorHero();
        if (debe && !this.iframe && paginaCargada) this.crear();
        if (!this.iframe) return;
        this.mandar(debe ? 'playVideo' : 'pauseVideo');
      }
    });
  }

  /* ── Hero rotativo ──
     Fotos: cada una su tiempo (data-segundos de la foto o de la sección).
     Videos: se ven COMPLETOS; el hero pasa al siguiente cuando el video
     termina. Si dura menos de 7 s se repite hasta llegar. Un temporizador
     de respaldo avanza igual si el navegador no lo deja reproducir (modo
     ahorro de batería del iPhone). */
  if (!customElements.get('rgt-home-hero')) {
    customElements.define('rgt-home-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = this.querySelectorAll('.rgt-home-hero__slide');
        this.puntos = this.querySelectorAll('.rgt-home-hero__punto');
        this.pausa = this.querySelector('.rgt-home-hero__pausa');
        this.i = 0;
        this.corriendo = !quieto;
        this.segundos = Number(this.dataset.segundos) || 6;

        this.puntos.forEach((p, n) => p.addEventListener('click', () => this.ir(n)));
        if (this.pausa) this.pausa.addEventListener('click', () => this.alternar());
        this.addEventListener('mouseenter', () => { this.encima = true; });
        this.addEventListener('mouseleave', () => { this.encima = false; });

        this.slides.forEach((slide, n) => {
          var v = slide.querySelector('video');
          if (!v) return;
          v.addEventListener('ended', () => {
            if (n !== this.i) return;
            var visto = (Date.now() - this.desde) / 1000;
            if (this.slides.length < 2 || !this.corriendo || visto < 7) {
              v.currentTime = 0;
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
              return;
            }
            this.ir(this.i + 1);
          });
        });

        this.pintarPausa();
        this.programar();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      videoActual() {
        return this.slides[this.i] && this.slides[this.i].querySelector('video');
      }

      programar() {
        clearTimeout(this.timer);
        this.desde = Date.now();
        if (this.slides.length < 2) return;
        var v = this.videoActual();
        var ms;
        if (v) {
          // Respaldo: lo que dura el video (o 20 s si aún no se sabe) + 4 s.
          var d = isFinite(v.duration) && v.duration > 0 ? v.duration : 20;
          ms = (Math.max(d, 7) + 4) * 1000;
        } else {
          var propia = Number(this.slides[this.i].dataset.segundos);
          ms = (propia || this.segundos) * 1000;
        }
        this.timer = setTimeout(() => this.vencido(), ms);
      }

      vencido() {
        var v = this.videoActual();
        // Una foto no cambia con el cursor encima; un video atascado sí.
        if (!this.corriendo || document.hidden || (this.encima && !v)) {
          this.timer = setTimeout(() => this.vencido(), 1500);
          return;
        }
        if (v && !v.paused && !v.ended) {
          this.timer = setTimeout(() => this.vencido(), 1500); // aún se está viendo
          return;
        }
        this.ir(this.i + 1);
      }

      videos() {
        return this.querySelectorAll('rgt-home-video, rgt-home-yt');
      }

      ir(n) {
        if (!this.slides.length) return;
        this.slides[this.i].classList.remove('is-on');
        if (this.puntos[this.i]) this.puntos[this.i].classList.remove('is-on');
        var viejo = this.videoActual();
        if (viejo) viejo.pause();
        this.i = (n + this.slides.length) % this.slides.length;
        this.slides[this.i].classList.add('is-on');
        if (this.puntos[this.i]) this.puntos[this.i].classList.add('is-on');
        var v = this.videoActual();
        if (v) {
          v.currentTime = 0;
          var cont = v.closest('rgt-home-video');
          requestAnimationFrame(() => { if (cont && cont.sincronizar) { cont.visible = true; cont.sincronizar(); } });
        }
        this.programar();
      }

      alternar() {
        this.corriendo = !this.corriendo;
        this.pintarPausa();
        this.videos().forEach(function (v) { if (v.sincronizar) v.sincronizar(); });
      }

      pintarPausa() {
        if (!this.pausa) return;
        this.pausa.setAttribute('aria-label', this.corriendo ? 'Pausar' : 'Reanudar');
        this.pausa.innerHTML = this.corriendo ? ICONO_PAUSA : ICONO_PLAY;
      }
    });
  }

  /* ── Flechas de los carriles ── */
  if (!customElements.get('rgt-home-carril')) {
    customElements.define('rgt-home-carril', class extends HTMLElement {
      connectedCallback() {
        var pista = this.querySelector('.rgt-home-carril');
        if (!pista) return;
        this.querySelectorAll('[data-dir]').forEach(function (b) {
          b.addEventListener('click', function () {
            pista.scrollBy({ left: Number(b.dataset.dir) * pista.clientWidth * 0.8, behavior: quieto ? 'auto' : 'smooth' });
          });
        });
      }
    });
  }
})();
